import {Component, Input, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.less']
})
export class ContentComponent {
    @Input() sidebar: TemplateRef<any> = null;
    @Input() breadcrumbsDisabled: boolean;
    @Input() breadcrumbsSidebarDisabled: boolean;
    @Input() fixedWidth: boolean;
}
